import styled from 'styled-components';
import ReactClipboard from 'react-clipboard.js';
import { palette } from './colors';

export const Clipboard = styled(ReactClipboard)`
    background: none;
    border: none;
    color: ${palette.evergreen.aspargus};
    border-radius: 5px;
    margin: 0px;
    font-size: 0.9em;
    transition:  all 0.2s ease;
    padding-left: 0;
`;
